<template>
    <div>
        <div class="table-values flex flex-nowrap justify-around p-4 pl-11 pt-3 bg-white overflow-x-auto border-b border-[#D9D5EC]"
            :class="{'bg-[#F2F0F9]' : showactions }">
            <p class="w-1/12"><base-checkbox class="" label="" v-model="terms_of_use" :bold="true" /></p>
            <!-- <p class="w-1/12"><base-checkbox class="-mt-2" label="" v-model="terms_of_use" :bold="true" /></p> -->
            <p class="w-3/12 overflow-wrap" v-for="header in activeHeaders" :key="header">
                <span v-if="header.name === 'ORIGIN'">
                    {{ getLocationDetails(dispatch.consolidation.origin).locationName }}
                </span>
                <span v-else-if="header.name === 'DESTINATION'">
                    {{ getLocationDetails(dispatch.consolidation.destination).locationName }}
                </span>
                <span v-else-if="header.name === 'DRIVER'">
                    {{ dispatch.consolidation.fleet ? dispatch.consolidation.fleet.user ? dispatch.consolidation.fleet.user.firstname + ' ' + dispatch.consolidation.fleet.user.lastname : "N/A" : "N/A" }}
                </span>
                <span class="rounded-xl overflow-wrap p-2 px-4 text-center bg-[#09B38A]" :class="{ 'status-green' : dispatch.dispatchStatus == 'dispatched' || dispatch.dispatchStatus == 'received' || dispatch.dispatchStatus == 'process_handoff', 'status-yellow' : dispatch.dispatchStatus == 'loading', 'status-pale' : dispatch.dispatchStatus == 'ready', 'status-any' : dispatch.dispatchStatus == 'on-hold' || dispatch.dispatchStatus == 'in-bound', 'status-red' : dispatch.dispatchStatus == 'accidented' || dispatch.dispatchStatus == 'delayed'  }" v-else-if="header.name === 'FLEET STATUS'">
                {{ dispatch.dispatchStatus == "received" && currentTab == "outgoing" ? 'Handed-off' : dispatch.dispatchStatus == "received" && currentTab == "incoming" ? capitalize(dispatch.dispatchStatus) : capitalize(dispatch.dispatchStatus) }}
                </span>
                <span v-else>
                    {{ getNestedValue(dispatch, headerMap[header.name]) }}
                </span>

            </p>
            <!-- <p class="w-3/12 overflow-wrap">{{ dispatch.dispatchReference }}</p> -->
            <!-- <p class="w-3/12 ml-2">{{ dispatch.consolidation.fleet ? dispatch.consolidation.fleet.equipment : "N/A" }}</p>
            <p class="w-5/12 ml-2 overflow-wrap ">{{ dispatch.consolidation.fleet ? dispatch.consolidation.fleet.vinnumber : "N/A" }}</p>
            <p class="w-3/12 ml-2">{{ dispatch.consolidation.fleet ? dispatch.consolidation.fleet.user ? dispatch.consolidation.fleet.user.firstname + ' ' + dispatch.consolidation.fleet.user.lastname : "N/A" : "N/A" }}</p>
            <p class="w-3/12 ml-2 overflow-wrap">{{ getLocationDetails(dispatch.consolidation.origin).locationName }}</p>
            <p class="w-3/12 ml-2">{{ getLocationDetails(dispatch.consolidation.destination).locationName }}</p>
            <p class="w-3/12 ml-2 break-all">{{ dispatch.consolidation.fleet ? dispatch.consolidation.fleet.currentLoadCapacity : "N/A"}} Tonnes</p>
            <p class="w-4/12 ml-2 overflow-wrap">
            <span class="rounded-xl overflow-wrap p-2 px-4 text-center bg-[#09B38A]" :class="{ 'status-green' : dispatch.dispatchStatus == 'dispatched' || dispatch.dispatchStatus == 'received' || dispatch.dispatchStatus == 'process_handoff', 'status-yellow' : dispatch.dispatchStatus == 'loading', 'status-pale' : dispatch.dispatchStatus == 'ready', 'status-any' : dispatch.dispatchStatus == 'on-hold' || dispatch.dispatchStatus == 'in-bound', 'status-red' : dispatch.dispatchStatus == 'accidented' || dispatch.dispatchStatus == 'delayed'  }">
                {{ dispatch.dispatchStatus == "received" && currentTab == "outgoing" ? 'Handed-off' : dispatch.dispatchStatus == "received" && currentTab == "incoming" ? capitalize(dispatch.dispatchStatus) : capitalize(dispatch.dispatchStatus) }}</span>
            </p>
            <p class="w-4/12 ml-2 overflow-wrap">{{ dispatch.dispatchReference}}</p>
            <p class="w-4/12 ml-2 overflow-wrap">{{ dispatch.dispatchReference}}</p>
            <p class="w-4/12 ml-2 overflow-wrap">{{ dispatch.dispatchReference}}</p> -->
            <div class="w-1/12 text-right">
                <el-dropdown trigger="click" placement="top" @command="showModal">
                    <button class="p-2 -mt-2 list-button w-full text-right text-[#6E6893] gap-4 rounded-md">
                        <img src="../../../../assets/images/icons/more-action-icon.png">
                    </button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img
                                        src="../../../../assets/images/icons/view-details-manifest.png" class=""></div>

                                <p class=""
                                    @click="$router.push({ name: 'DispatchManifest', params : { dispatchID : dispatch.id } } )">
                                    View Manifest</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="onDispatch" v-if="currentTab == 'outgoing'"
                            command="dispatchmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/delivery-truck.png"
                                        class=""></div>

                                <p class="">Dispatch</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div
                                @click="$router.push({ name: 'DispatchTimeline' ,params : { dispatchID : dispatch.id }})">
                                <button class="flex flex-nowrap w-full p-1 text-left">
                                    <div class="pt-2 mr-3"><img
                                            src="../../../../assets/images/icons/view-details-timeline.png" class="">
                                    </div>

                                    <p class="">View Timeline</p>
                                </button>
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'" command="statusmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/update-arrows.png"
                                        class=""></div>

                                <p class="">Update Status</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'" command="processhandoffmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/hand-shake.png"
                                        class=""></div>

                                <p class="">Process Handoff</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'incoming'" command="receiveshipmentmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/hand-shake.png"
                                        class=""></div>

                                <p class="">Receive Shipment</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item hidden v-if="currentTab == 'outgoing'" command="showProcessFulfillmentModal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img
                                        src="../../../../assets/images/icons/process-fulfillment-icon.png" class="">
                                </div>

                                <p class="">Process Fulfillment</p>
                            </button>
                        </el-dropdown-item>

                        <el-dropdown-item :disabled="onDispatch" v-if="currentTab == 'outgoing'"
                            command="putonholdmodal">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <img src="../../../../assets/images/icons/hand-up.png" class="mr-1">
                                <p class="">Put on Hold</p>
                            </button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="currentTab == 'outgoing'" :disabled="onDispatch"
                            command="canceldispatch">
                            <button class="flex flex-nowrap w-full p-1 text-left">
                                <div class="pt-2 mr-3"><img src="../../../../assets/images/icons/cancel-icon.png"
                                        class=""></div>

                                <p class="">Cancel</p>
                            </button>
                        </el-dropdown-item>

                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <el-dialog :visible.sync="successfulDispatch" width="35%">
                <div class="text-center modals-wrapper">
                    <img src="../../../../assets/images/icons/successful-dispatching-icon.png" class=" mx-auto">
                    <p class="mt-10 w-3/4 mx-auto mb-4 text-lg">Your shipment has been dispatched successfully!</p>
                </div>
            </el-dialog>

            <UpdateStatusModal :showmodal="showupdateModal" :currentStatus="dispatch.dispatchStatus"
                :lastUpdated="dispatch.updatedAt" :dispatchId="dispatch.id"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="showupdateModal = false"
                :statuses="statuses" />

            <FinalPutOnHoldModal :showmodal="showfinalholdmodal" :dispatchId="dispatch.id"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="showfinalholdmodal = false" />

            <PutOnHoldModal :showmodal="putholdModal" :dispatchId="dispatch.id"
                @refetch-dispatch="$emit('refetch-dispatch')" @show-final-hold="showfinalholdmodal = true"
                @close-modal="putholdModal = false" />

            <ProcessHandOffModal :showModal="processhandoffModal" :dispatch="dispatch"
                @refetch-dispatch="$emit('refetch-dispatch')" @show-confirm-handoff="showConfirmHandoff"
                @close-modal="processhandoffModal = false" />

            <ConfirmHandoffModal :showModal="confirmhandoffModal" :processObj="processObj" :dispatch="dispatch"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="confirmhandoffModal = false" />

            <CancelDispatchModal :showmodal="canceldispatchshow" :dispatchId="dispatch.id"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="canceldispatchshow  = false" />

            <receive-shipping-modal :show-modal="showReceiveShippingModal" :dispatch="dispatch"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="showReceiveShippingModal = false" />

            <el-dialog :visible.sync="requestsentModal" title="" width="35%">
                <div class="text-center modals-wrapper px-5">
                    <img src="../../../../assets/images/icons/handoff-requestsent-icon.png" class=" mx-auto">
                    <p class="text-lg mt-4 font-semibold" style="color:#FCC210">Request Sent!</p>
                    <p class="mt-4 w-11/12 text-lg">Handoff receipt request sent successfully</p>
                </div>
            </el-dialog>

            <DispatchModal :showmodal="statusDispatch" :dispatchId="dispatch.id"
                @refetch-dispatch="$emit('refetch-dispatch')" @close-modal="statusDispatch = false"
                @show-successful-dispatch="successfulDispatch = true" />

            <ProcessFulfillmentModal :dispatch="dispatch" :showmodal="showProcessFulfillmentModal"
                @close-modal="showProcessFulfillmentModal = false" @show-request-sent="messageId = $event"
                @show-return-details="showConfirmFulfilment = true" />
            <ReturnDetailsModal :showmodal="returndetailsmodal" @close-modal="returndetailsmodal = false"
                @show-return-cost="returncostmodal = true" />

            <ReturnCostModal :showmodal="returncostmodal" @close-modal="returncostmodal = false" />

            <confirm-fulfillment-modal :show-modal="showConfirmFulfilment" @refetch-dispatch="$emit('refetch-dispatch')"
                @show-request-sent="showRequestSentModal = true;showConfirmFulfilment = true" :messageId="messageId"
                @close-modal="showConfirmFulfilment = false" :dispatch="dispatch" :action="action" />

            <request-sent-modal type="fulfillment" :show-modal="showRequestSentModal"
                @close-modal="showRequestSentModal = false" />
        </div>

    </div>

</template>

<script>

import ProcessFulfillmentModal from "./Modals/ProcessFulfillmentModal"
import ReturnDetailsModal from "./Modals/ReturnDetailsModal"
import ReturnCostModal from "./Modals/ReturnCostModal"
import DispatchModal from "./Modals/DispatchModal"
import UpdateStatusModal from "./Modals/UpdateStatusModal"
import PutOnHoldModal from "./Modals/PutOnHoldModal"
import CancelDispatchModal from "./Modals/CancelDispatchModal"
import FinalPutOnHoldModal from "./Modals/FinalPutOnHoldModal"
import ConfirmFulfillmentModal from "./Modals/ConfirmFulfillmentModal.vue";
import RequestSentModal from "./Modals/RequestSentModal";
import ProcessHandOffModal from "./Modals/ProcessHandoffModal"
import ConfirmHandoffModal from "./Modals/ConfirmHandoffModal"
import ReceiveShippingModal from "./Modals/ReceiveShippingModal.vue"

export default {
    components : {
        ProcessFulfillmentModal,
        ReturnDetailsModal,
        ReturnCostModal,
        DispatchModal,
        UpdateStatusModal,
        PutOnHoldModal,
        CancelDispatchModal,
        FinalPutOnHoldModal,
        ConfirmFulfillmentModal,
        RequestSentModal,
        ProcessHandOffModal,
        ConfirmHandoffModal,
        ReceiveShippingModal
    },
    props : ['dispatch', 'currentTab', "shippingServices", "locations", "activeHeaders"],
    data(){
        return {
            statuses:[
                {
                    name: 'Received',
                    value: 'received'
                },
                {
                    name: 'Ready',
                    value: 'ready'
                },
                {
                    name: 'Accidented',
                    value: 'accidented'
                },
                {
                    name: 'Delayed',
                    value: 'delayed'
                },
                {
                    name: 'In-bound',
                    value: 'in-bound'
                },
                {
                    name: 'Dispatched',
                    value: 'dispatched'
                },
                {
                    name: 'On-hold',
                    value: 'on-hold'
                },
            ],
            headerMap: {
                "DISPATCH REF." : 'dispatchReference',
                "FLEET NAME" : 'consolidation.fleet.equipment',
                "FLEET REG NO." : 'consolidation.fleet.vinnumber',
                "DRIVER" : '',
                'ORIGIN' : '',
                'DESTINATION' : '',
                "LOAD CAPACITY" : 'consolidation.fleet.currentLoadCapacity',
                "FLEET STATUS" : '',
                "Load status" : 'consolidation.status',
                "Estimated drop off date" : '', 
                "Estimated drop off time" : '', 
            },
            terms_of_use : false,
            showactions : false,
            statusDispatch : false,
            putholdModal : false,
            showfinalholdmodal : false,
            successfulDispatch : false,
            showupdateModal : false,
            processhandoffModal :false,
            showProcessFulfillmentModal : false,
            confirmprocesshandoffModal : false,
            requestsentModal : false,
            processreturnmodal : false,
            returndetailsmodal : false,
            returncostmodal : false,
            canceldispatchshow : false,
            showConfirmFulfilment : false,
            showRequestSentModal : false,
            confirmhandoffModal : false,
            showReceiveShippingModal: false,
            putonholdreason : "",
            booking : {},
            deliveryDate : new Date(),
            user : {},
            messageId: ""
        }
    },
    methods : {

        getNestedValue(obj, path) {
            const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
            return value === null || value === undefined || value === '' ? 'N/A' : value;
        },
        
        capitalize(str){
            let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

            return capitalizedstr
        },
        showModal(modal){

            if(modal == 'dispatchmodal'){
                this.statusDispatch = true
            }else if(modal == 'putonholdmodal'){
                this.putholdModal = true
            }else if(modal == 'statusmodal'){
                this.showupdateModal = true
            }else if(modal == 'processhandoffmodal'){
                this.processhandoffModal = true
            }else if(modal == 'processreturnModal'){
                this.processreturnmodal = true
            }else if(modal == 'canceldispatch'){
                this.canceldispatchshow = true
            }else if(modal == 'showProcessFulfillmentModal'){
                this.showProcessFulfillmentModal = true
            }else if(modal == 'receiveshipmentmodal'){
                this.showReceiveShippingModal = true
            }
        },
        showConfirmHandoff(processObj) {
            this.processObj = processObj;
            console.log(processObj)
            this.confirmhandoffModal = true;
        },
        
    },
    computed : {
        onDispatch(){
            return this.dispatch.dispatchStatus == 'dispatched' || this.dispatch.dispatchStatus == 'accidented' || this.dispatch.dispatchStatus == 'received' || this.dispatch.dispatchStatus == 'delayed' ? true : false
        }
    }
}
</script>

<style lang="scss" scoped>

.table-values{
    p{
        font-weight: 500;
    }
    .status-green{
        background-color : #09B78A33;
        color : #09B78A;
        font-size: 14px
    }
    .status-yellow{
        background-color: #FFA60033;
        color : #FFA600;
        font-size : 14px
    }
    .status-pale{
        background-color: #10233E33;
        color : #10233E;
        font-size : 14px
    }
    .status-any{
        background-color: #FFA60033;
        color : #FFA600;
        font-size: 14px
    }
    .status-red{
        background-color: #D7263833;
        color: #D72638;
        font-size: 14px;
    }
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
}
</style>